export default __webpack_public_path__ + "static/media/tablet.58178a29.jpg";